import { Component } from '@angular/core';

@Component({
    selector: 'app-notification-center',
    templateUrl: './notification-center.component.html',
    styleUrls: ['./notification-center.component.scss'],
    standalone: false
})
export class NotificationCenterComponent {
  pageTitle = 'Notification Center';
}
